import { useQuery } from '@apollo/client';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import CustomLayout from 'component/layout/custom_layout';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import { STRINGS } from '../../constants';
import { cache } from 'graph_ql';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { SEARCH_ITEM_CREATED } from 'graph_ql/search/search_item_created';
import { COUNT_MY_STYLES } from 'graph_ql/styles/queries';
import { useCacheQueryData } from 'hooks/useCacheQuery';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { RootState } from 'redux/store';
import { PATH } from 'routes/constant';
import { getUserProfilePhoto } from 'utils/getUserProfilePhoto';
import { useStyles } from './style';
import themes from 'styles/themes';
import config from 'config';
function StylistProfile() {
    const classes = useStyles();
    const userData = useSelector((state: RootState) => state.userDetail.me);
    const [me, setMe] = useState(userData);
    const user: any = useCacheQueryData(USER_DETAIL, null, true, 'cache-only');
    const [userDetail, setUserDetail] = useState(user?.dataQuery?.me);
    useEffect(() => {
        if (user && user.dataQuery?.me) {
            setUserDetail(user.dataQuery?.me);
        }
    }, [user]);
    useEffect(() => {
        setMe(userData);
    }, [userData]);
    const data = useQuery(COUNT_MY_STYLES, {
        variables: {
            query: '',
            hit: 1,
            page: 0,
            filters: `user.id:${user?.dataQuery?.me?.id}`,
        },
        fetchPolicy: 'network-only',
        skip: !user?.dataQuery?.me?.id,
    });
    const searchVariables = useMemo(() => {
        cache.modify({
            fields: {
                items(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        let filters;
        filters = `creator:"${userDetail?.id || me?.id}" AND status: available`;

        return {
            index: config.algolia.algolia_prefix + 'item_created',
            query: '',
            filters,
            hit: 1,
            page: 0,
            facets: ['title', 'tags.name', 'sizes.title'],
        };
    }, [me?.id, userDetail?.id]);

    const { data: myItems } = useQuery(SEARCH_ITEM_CREATED, {
        variables: searchVariables,
    });

    return (
        <>
            {data.loading && <LoadingDataSpinner />}
            <CustomLayout title="Profile" showBackBtn={false} backTo="/home">
                <div id="main" className={classes.main}>
                    <NavLink to={PATH.PROFILE_INFO} style={{ textDecoration: 'none' }}>
                        <div id="personal" className={classes.personal}>
                            <figure style={{ minWidth: 72, minHeight: 72 }}>
                                <img src={getUserProfilePhoto(me)} alt="profile" className={classes.personalImg} />
                            </figure>
                            <div className={classes.personalInfo}>
                                <p
                                    style={{
                                        fontSize: 16,
                                        fontWeight: 400,
                                        color: themes.palette.primary.main,
                                        fontFamily: 'PoppinsRegular',
                                        margin: '4px 0',
                                    }}
                                >
                                    {me?.firstName} {me?.lastName}
                                </p>
                                <p
                                    style={{
                                        fontSize: 14,
                                        fontWeight: 400,
                                        color: themes.palette.primary.main,
                                        fontFamily: 'PoppinsRegular',
                                        opacity: '0.5',
                                        margin: '4px 0',
                                    }}
                                >
                                    {me?.phone}
                                </p>
                            </div>
                        </div>
                    </NavLink>
                    <div className={classes.contnentPage}>
                        <NavLink to={PATH.STYLIST_DASHBOARD} className={classes.link}>
                            <div className={classes.option}>
                                <div>
                                    <p
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 400,
                                            color: themes.palette.primary.main,
                                            fontFamily: 'PoppinsRegular',
                                            margin: '4px 0',
                                        }}
                                    >
                                        My Dashboard
                                    </p>
                                </div>
                                <span>
                                    <ArrowForwardIosIcon style={{ color: themes.palette.primary.main, width: 15 }} />
                                </span>{' '}
                            </div>
                        </NavLink>
                        <NavLink
                            to={`${PATH.STYLIST_PROFILE}/${me?.userName || userDetail?.userName}`}
                            className={classes.link}
                        >
                            <div className={classes.option}>
                                <div>
                                    <p
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 400,
                                            color: themes.palette.primary.main,
                                            fontFamily: 'PoppinsRegular',
                                            margin: '4px 0',
                                        }}
                                    >
                                        My Public Profile
                                    </p>
                                </div>
                                <span>
                                    <ArrowForwardIosIcon style={{ color: themes.palette.primary.main, width: 15 }} />
                                </span>{' '}
                            </div>
                        </NavLink>
                        <NavLink to={PATH.MY_STYLES} className={classes.link}>
                            <div className={classes.option}>
                                <div>
                                    <p
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 400,
                                            color: themes.palette.primary.main,
                                            fontFamily: 'PoppinsRegular',
                                            margin: '4px 0',
                                        }}
                                    >
                                        My Styles
                                    </p>
                                    <p
                                        style={{
                                            fontSize: 12,
                                            fontWeight: 400,
                                            color: themes.palette.primary.main,
                                            fontFamily: 'PoppinsRegular',
                                            opacity: '0.5',
                                            margin: '4px 0',
                                        }}
                                    >
                                        {data?.data?.locationsInRadius?.nbHits} styles
                                    </p>
                                </div>
                                <span>
                                    <ArrowForwardIosIcon style={{ color: themes.palette.primary.main, width: 15 }} />
                                </span>{' '}
                            </div>
                        </NavLink>
                        <NavLink to={PATH.MY_ITEMS} className={classes.link}>
                            <div className={classes.option}>
                                <div>
                                    <p
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 400,
                                            color: themes.palette.primary.main,
                                            fontFamily: 'Graphik',
                                            margin: '4px 0',
                                        }}
                                    >
                                        {STRINGS.MY_ITEMS}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: 12,
                                            fontWeight: 400,
                                            color: themes.palette.primary.main,
                                            fontFamily: 'Graphik',
                                            opacity: '0.5',
                                            margin: '4px 0',
                                        }}
                                    >
                                        {myItems?.items?.nbHits} items
                                    </p>
                                </div>
                                <span>
                                    <ArrowForwardIosIcon style={{ color: themes.palette.primary.main, width: 15 }} />
                                </span>{' '}
                            </div>
                        </NavLink>
                        <NavLink to={PATH.MY_STYLE_REQUESTS} className={classes.link}>
                            <div className={classes.option}>
                                <div>
                                    <p
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 400,
                                            color: themes.palette.primary.main,
                                            fontFamily: 'PoppinsRegular',
                                            margin: '4px 0',
                                        }}
                                    >
                                        My Style Requests
                                    </p>
                                </div>
                                <span>
                                    <ArrowForwardIosIcon style={{ color: themes.palette.primary.main, width: 15 }} />
                                </span>{' '}
                            </div>
                        </NavLink>
                        <NavLink to={PATH.CONNECTED_ACCOUNTS} className={classes.link}>
                            <div className={classes.option}>
                                <div>
                                    <p
                                        style={{
                                            fontSize: 16,
                                            fontWeight: 400,
                                            color: themes.palette.primary.main,
                                            fontFamily: 'PoppinsRegular',
                                            margin: '4px 0',
                                        }}
                                    >
                                        My Connected Accounts
                                    </p>
                                </div>
                                <span>
                                    <ArrowForwardIosIcon style={{ color: themes.palette.primary.main, width: 15 }} />
                                </span>{' '}
                            </div>
                        </NavLink>
                    </div>
                </div>
            </CustomLayout>
        </>
    );
}

export default StylistProfile;
